import { FormattedMessage } from "react-intl";
import useResponsive from "../../../hooks/useResponsive";
import { PropsWithClassName } from "../../../models/props-with-class-name";
import SearchBox from "../../Tree/SearchBox/SearchBox";
import { Button } from "@shltelemedicine/shl-ui-lib";
import styles from "./SearchAndFilter.module.css";

type SearchAndFilterProps = PropsWithClassName<{
  disabled?: boolean;
  searchText?: string;
  onSearchTextChange?: (text: string) => void;
  toggleFilter?: () => void;
  filterOpen?: boolean;
  onClearSearch?: () => void;
  showFilterBtn?: boolean;
}>;

const SearchAndFilter = ({
  disabled,
  searchText,
  onSearchTextChange,
  toggleFilter,
  onClearSearch,
  filterOpen,
  className,
  showFilterBtn = true,
}: SearchAndFilterProps) => {
  const { isMobile } = useResponsive();
  const searchingOnMobile = isMobile && searchText;

  return (
    <div
      className={`p-lg-2 pr-lg-4 p-0 d-flex align-items-center justify-content-between ${className}`}
    >
      <div className="flex-grow-1">
        <SearchBox
          disabled={disabled}
          value={searchText}
          onChange={onSearchTextChange}
        />
      </div>
      <span className="mx-sm-1"></span>
      {showFilterBtn && (
        <div className={`${searchingOnMobile && "d-none"}`}>
          <Button
            onClick={toggleFilter}
            className={`${styles.filterButton} ${filterOpen && styles.open}
          d-flex flex-row align-items-center py-1 px-2`}
            size="sm"
            variant=""
            disabled={disabled}
          >
            <i className="fas fa-filter mx-1"></i>
            <FormattedMessage id="FILTER.TITLE" defaultMessage="Filter" />
          </Button>
        </div>
      )}
      {searchText && (
        <>
          <span className="mx-sm"></span>
          <Button
            className={`${styles.closeButton} d-flex flex-row align-items-center py-1 px-2`}
            size="sm"
            variant=""
            bgColor="rgba(25, 73, 203, .2)"
            onClick={onClearSearch}
            disabled={disabled}
          >
            <span>&#10006;</span>
            <span className="mx-sm"></span>
            <FormattedMessage
              id="ECGS_FILTER.CLOSE_RESULTS"
              defaultMessage="Close Results"
            />
          </Button>
        </>
      )}
    </div>
  );
};

export default SearchAndFilter;
